var _rect, _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 4,
    fill: "#D0CECD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.5192,
    cy: 49.5195,
    r: 31.25,
    fill: "#757575"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_215_4861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.5193 53.6868C51.8205 53.6868 53.6859 51.8214 53.6859 49.5202C53.6859 47.219 51.8205 45.3535 49.5193 45.3535C47.2181 45.3535 45.3526 47.219 45.3526 49.5202C45.3526 51.8214 47.2181 53.6868 49.5193 53.6868Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.613 36.498L43.2302 39.1022H39.1026C37.6703 39.1022 36.4984 40.2741 36.4984 41.7064V57.3314C36.4984 58.7637 37.6703 59.9355 39.1026 59.9355H59.9359C61.3682 59.9355 62.5401 58.7637 62.5401 57.3314V41.7064C62.5401 40.2741 61.3682 39.1022 59.9359 39.1022H55.8083L53.4255 36.498H45.613ZM49.5192 56.0293C45.9255 56.0293 43.0088 53.1126 43.0088 49.5189C43.0088 45.9251 45.9255 43.0085 49.5192 43.0085C53.113 43.0085 56.0297 45.9251 56.0297 49.5189C56.0297 53.1126 53.113 56.0293 49.5192 56.0293Z",
    fill: "#FCFCFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_215_4861"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.25,
    height: 31.25,
    fill: "white",
    transform: "translate(33.8942 33.8945)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPhoto);
export default __webpack_public_path__ + "static/media/noPhoto.07ae0b8128b30497d08e24d2b5758c89.svg";
export { ForwardRef as ReactComponent };